<template>
  <el-dialog
    class="site-deploy"
    title="场地配置"
    :visible.sync="dialogVisible"
    top="5vh"
    width="95%"
    :append-to-body="true"
    @closed="reset"
    :modal-append-to-body="false"
  >
    <div class="site-box">
      <div v-for="(which, index1) in total_data" :key="index1">

        <div v-if="which.round === '1R'" style="display: flex;">
          <div
            style="
              margin: 30px 0;
              width: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
              color: #000;
              font-weight: bold;
              border: 1px solid #000;
              border-right: none;
              background-color: #d9e1f2;
            "
          >{{ which.round }}</div>
          <el-table
            class="table"
            :header-row-class-name="table_header"
            header-cell-class-name="table_cell"
            :cell-class-name="table_cell"
            border
            :data="which.tableData"
          >
            <el-table-column
              :label="`
                ${title}
                \u3000\u3000\u3000\u3000\u3000
                ${firstFormat[ruleForm.firstFormat] || ''}
                \u3000\u3000\u3000\u3000\u3000
                ${secondFormat[ruleForm.secondFormat] || ''}
              `"
              align="center"
            >
              <template v-if="which.labelData[0].tip">
                <el-table-column
                  v-for="(item, index) in tableCellCom(which.labelData)"
                  :key="index"
                  class-name="gap-cell"
                  :label="tableCellCom(which.labelData)[index][0].tip"
                  align="center"
                >
                  <el-table-column
                    v-for="(item, index2) in tableCellCom(which.labelData)[index]"
                    :key="index2"
                    class-name="gap-cell"
                    :prop="item.prop"
                    :label="item.label"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="scope.row[item.prop]" placeholder="场地号" />
                    </template>
                  </el-table-column>
                </el-table-column>
              </template>
              <template v-else>
                <el-table-column
                  v-for="(item, index2) in which.labelData"
                  :key="index2"
                  class-name="gap-cell"
                  :prop="item.prop"
                  :label="item.label"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input v-model="scope.row[item.prop]" placeholder="场地号" />
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table_box" v-else>
          <h3 class="title">{{ which.round }}</h3>
          <el-table
            class="table"
            header-row-class-name="table_header header_subtitle"
            header-cell-class-name="table_cell"
            cell-class-name="table_cell"
            border
            :data="which.tableData"
          >
            <el-table-column v-for="(item, index) in which.labelData" :key="index" :prop="item.prop" :label="item.label" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row[item.prop]" placeholder="场地号"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>
      <div class="btn_box">
        <el-button @click="cancel">返回</el-button>
        <el-button class="save" type="primary" @click="submit">保 存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Query, Update } from '@/api/pages/ct/competition/club-level/site-deploy.js'

export default {
  data () {
    return {
      dialogVisible: false,
      total_data: [],
      title: null,
      ctId: null,
      ruleForm: {
        firstFormat: '',
        secondFormat: ''
      },
			firstFormat: {
				0: '淘汰附加赛',
				1: '小组循环赛',
				5: '淘汰赛',
				6: '6签位循环赛',
				7: '3局2胜赛'
      },
			secondFormat: {
				2: '同名次小组循环赛',
				3: '同名次淘汰附加赛',
				4: '交叉淘汰附加赛',
				5: '淘汰赛'
      }
    }
  },
  computed: {
    tableCellCom () {
      return function (arr) {
        const map = {}
        arr.forEach(item => {
          if (!map[item.tip]) {
            map[item.tip] = []
          }
          map[item.tip].push(item)
        })
        return Object.values(map)
      }
    }
  },
  methods: {
    init (rows) {
      this.ctId = rows.id
      let params = {
        ctId: rows.id
      }
      Query(params).then(data => {
        if (data && data.code === 0) {
          if (!data.data) {
            this.$confirm(`您好，暂未生成场地信息。`, '提示', {
              showCancelButton: false,
              confirmButtonText: '确定',
              type: 'warning'
            })
              .then(async () => {

              })
            return false
          }
          this.total_data = []
          let {
            matchName,
            firstStage,
            secondStage
          } = data.data
          secondStage = secondStage === null ? [] : secondStage
          this.title = matchName
          // 处理数据
          let res = firstStage.concat(secondStage)
          res.forEach(which => {
            let {
              round,
              againstSignList
            } = which
            let labelData = []
            let tableData = [{}]

            againstSignList.forEach((item, index) => {
              // 解构赋值
              let {
                againstLabel,
                againstSign,
                competitionTerrainId,
                competitionTerrainOne
              } = item
              // 表格label(胜VS胜)
              let obj = {
                tip: againstLabel,
                label: againstSign,
                prop: competitionTerrainId
              }
              labelData.push(obj)
              // table每一项的值
              tableData[0][competitionTerrainId] = competitionTerrainOne
            })

            let tmp = {
              labelData,
              tableData,
              round: round + 'R'
            }
            this.total_data.push(tmp)
          })
          this.dialogVisible = true
        }
      })
      this.$http({
				url: this.$http.adornUrl(`/ctCompetition/getId/` + this.ctId),
				method: 'get'
			})
        .then(res => {
          this.ruleForm.firstFormat = ''
          this.ruleForm.secondFormat = ''
          if (res.bean.competitionMatchFormatList.length != 0) {
            this.ruleForm.firstFormat = res.bean.competitionMatchFormatList[0].matchFormat
            if (res.bean.competitionMatchFormatList.length > 1) {
              this.ruleForm.secondFormat = res.bean.competitionMatchFormatList[1].matchFormat
            }
          }
        })
    },
    table_header ({ rowIndex }) {
      switch (rowIndex) {
        case 0:
          return 'header_headline table_header'
        case 1:
          return 'header_subtitle table_header'
        default:
          break
      }
    },
    table_cell ({ column }) {
      let { label } = column
      if (
        label === '1R' ||
        label === '2R' ||
        label === '3R' ||
        label === '4R'
      ) {
        return 'table_cell cell_title'
      } else {
        return 'table_cell'
      }
    },
    submit () {
      // 处理数据
      let resData = []
      this.total_data.forEach(which => {
        let arrTmp = []
        let { tableData } = which
        let keys = Object.keys(tableData[0])
        keys.forEach(itemKey => {
          if (itemKey !== 'title') {
            let obj = {}
            obj.ctId = this.ctId
            obj.competitionTerrainId = itemKey
            obj.competitionTerrainOne = tableData[0][itemKey]
            arrTmp.push(obj)
          }
        })
        resData = resData.concat(arrTmp)
      })
      let data = resData
      Update(data).then(res => {
        this.$message.success(res.data)
      })
    },
    cancel () {
      this.dialogVisible = false
    },
    reset () {
      this.total_data = []
      this.title = null
      this.ctId = null
    }
  }
}
</script>

<style lang="scss" scoped>
.site-deploy {
  .site-box {
    width: 95%;
    margin: 0 auto;

    .table_box {
      display: flex;
      margin: 30px auto;

      .title {
        width: 100px;
        box-sizing: border-box;
        background: #d9e1f2;
        font-weight: bold;
        text-align: center;
        font-size: 16px;
        letter-spacing: 2px;
        color: #000;
        border: 1px solid #000;
        border-right: none;
        line-height: 88px;
      }

      .table {
        width: 100%;
        margin: 0;
      }
    }

    .table {
      margin: 30px auto;
      border: 1px #000 solid;
    }

    .btn_box {
      display: flex;
      flex-direction: row-reverse;

      .save {
        margin-right: 10px;
      }
    }
  }
}
</style>

<style lang="scss">
.site-deploy {
  .table {
    td {
      padding: 0;
    }

    .el-table__row .cell .el-input__inner {
      border: none;
      text-align: center;
      padding: 0 8px;

      &::-webkit-input-placeholder {
        color: #606266;
      }

      &::-moz-input-placeholder {
        color: #606266;
      }

      &::-ms-input-placeholder {
        color: #606266;
      }
    }

    .table_header {
      th {
        background: #d9e1f2 !important;
        color: #000;
      }
    }

    .header_headline {
      th {
        font-size: 16px;
        letter-spacing: 2px;
      }
    }

    .header_subtitle {
      th {
        font-weight: 400;
      }
    }

    .table_cell {
      border-color: #000;
    }

    .cell_title {
      font-weight: bold;
      color: #000;
    }
  }

  th.gap-cell {
    color: #000;
    font-weight: normal;
    font-size: 15px;
    background-color: #d9e1f2 !important;
  }
}
</style>
